import { createBrowserRouter, Navigate, Outlet } from "react-router";
import {modulesRouter} from "../features/erp/router/modules.routes";
import LoginPage from "@/features/auth/login/Login.page";
import MarketingLayout from "@/features/marketing/layout/Marketing.layout";
import { marketingRoutes } from "@/features/marketing/marketing.routes";
import { useAuthLoader } from "@/loaders/auth/useAuthLoader";
import { useAuthLoaderData } from "@/loaders/auth/useAuthLoaderData";

export const router = createBrowserRouter( [    
    //======================= Rutas protegidas =======================
    {           
        path: "/",        
        id: "root",
        loader: useAuthLoader,
        HydrateFallback: () => null,         
        children: [                 
            //Rutas de la pagina de marketing
            {                     
                Component: () => <MarketingLayout />,        
                children: marketingRoutes
            },
            
            //Rutas de autenticacion    
            {                                                
                path: "/login",                          
                Component: () => {
                    const session = useAuthLoaderData()
                    return session?.user ? <Navigate to={"/providers"} replace /> : <LoginPage />
                },
            },            

            //Rutas de los modulos  
            {
                Component: () => {
                    const session = useAuthLoaderData()
                    return session?.user ? <Outlet /> : <Navigate to={"/login"} replace />
                },
                children: [                    
                    modulesRouter
                ]
            },
        ]                    
    },    
])